import React from "react";
import CollapsibleCard from "@/components/atomics/collapsible-card";
import TextArea from "@/components/atomics/text-area";
import Social from "@/components/molecules/owner/social";
import { ViewState, OwnerState, OwnerSocial } from "@/types/owner-edit";
import { ownerEditUtils } from "@/utils/owner-edit";
import { OWNER_EDIT_CONSTANTS } from "@/constants/owner-edit";

interface OwnerSectionsProps {
  ownerData: OwnerState;
  viewState: ViewState;
  onUpdateInfo: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onUpdateSocial: (index: number, value: string) => void;
}

const OwnerSections: React.FC<OwnerSectionsProps> = ({
  ownerData,
  viewState,
  onUpdateInfo,
  onUpdateSocial,
}) => {
  const hasSocials = ownerEditUtils.hasSocialLinks(ownerData.socials);
  console.log("Social section exists");
  return (
    <>
      <CollapsibleCard
        editTitle="MY INFO"
        viewTitle="info:"
        className="text-[30px]"
        viewClassName="text-[23px]"
        isEditView={viewState.isEditView}
      >
        <TextArea
          className=""
          value={ownerData.info}
          totalTextCount={OWNER_EDIT_CONSTANTS.MAX_INFO_LENGTH}
          notEditable={!viewState.isEditView}
          onChange={onUpdateInfo}
        />
      </CollapsibleCard>

      {(hasSocials || viewState.isEditView) && (
        <CollapsibleCard
          editTitle="My LINKS"
          viewTitle=""
          className="text-[30px]"
          viewClassName="text-[23px]"
          isEditView={viewState.isEditView}
        >
          <div
            className={`flex ${viewState.isEditView ? "flex-col gap-[10px]" : "flex-row gap-[20px]"} py-[30px]`}
          >
            {ownerData.socials.map((social, index) => (
              <Social
                key={`${social.name}-${index}`}
                {...{ [social.name]: social.link }}
                name={social.name}
                value={social.link}
                onChange={value => onUpdateSocial(index, value)}
                isEditView={viewState.isEditView}
              />
            ))}
          </div>
        </CollapsibleCard>
      )}
    </>
  );
};

export default OwnerSections;
